import styled, { css, DefaultTheme } from 'styled-components'

export interface IframeProps {
  theme?: DefaultTheme
  colorScheme?: string
}

export const Iframe = styled.div<IframeProps>`
  padding-top: ${({ theme }) => theme.rem(24)};
  padding-bottom: ${({ theme }) => theme.rem(24)};

  ${({ theme }) => theme.mediaQuery.lg(`
    padding-top: ${theme.rem(40)};
    padding-bottom: ${theme.rem(40)};
  `)}

  ${({ theme, colorScheme }) => css`
    background-color: ${theme.colorScheme[`${colorScheme}`].surface.inside};
    color: ${theme.colorScheme[`${colorScheme}`].surface.text.base.primary};
  `}

  iframe {
    width: 100%;
    border: none;
  }
`
